import React from "react";
import { useTranslation } from "react-i18next";
import { Form, DatePicker, Typography } from "antd";
import moment from "moment";
import { SEC_FONT_GREY } from "../../constant/colors";
import { DATE_FORMAT_1 } from "../../utils/date";

const { Text } = Typography;

const ArrivedDateFormItem = ({
  style,
  title,
  required = false,
  editable = true,
  showLabel = false,
  strong = false,
  defaultValue,
  id,
  dataTMId,
  onChange,
  name = "arriveDate",
  recordInfo
}) => {
  const { t } = useTranslation();
  return (
    <Form.Item
      name={recordInfo ? [recordInfo.key, recordInfo.dataIndex] : name}
      label={
        showLabel ? (
          <Text strong={strong} style={{ color: SEC_FONT_GREY }}>
            {title ? title : t("form.arrive_date.label")}
          </Text>
        ) : null
      }
      style={style}
      colon={false}
      rules={[{ required, message: t("form.arrive_date.error_required") }]}
    >
      {editable ? (
        <DatePicker
          style={{ width: "100%" }}
          placeholder={t("form.arrive_date.placeholder")}
          disabled={!editable}
          format={DATE_FORMAT_1}
          allowClear={true}
          onSelect={onChange}
          id={id}
        />
      ) : (
        <Text id={id} data-tm-id={dataTMId}>
          {defaultValue ? `${moment(defaultValue).format(DATE_FORMAT_1)}` : "-"}
        </Text>
      )}
    </Form.Item>
  );
};

export { ArrivedDateFormItem };
